import { environnement } from "configs/environnement";
import api from "./api";
import {
  IDepartmentResponse,
  ISaveDepartment,
  IUpdateDepartment,
} from "models/church.types";

export const DepartmentService = {
  /**
   * Récupérer la liste complète des départements (paginée)
   * Utilise la route de recherche sans query pour tout récupérer
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IDepartmentResponse[]>(
      `${environnement.baseURL}/departments/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * Récupérer la liste complète des départements sans pagination
   * Utile pour les listes déroulantes (Select) dans les formulaires
   */
  getAllSimple: async (): Promise<IDepartmentResponse[]> => {
    const response = await api.get<IDepartmentResponse[]>(
      `${environnement.baseURL}/departments/_search`,
      {
        params: {
          page: 0,
          size: 1000,
          sort: "name,asc",
        },
      },
    );
    return response.data;
  },

  /**
   * Créer un nouveau département
   * @param department de type ISaveDepartment (name, description, managerId)
   */
  create: async (department: ISaveDepartment): Promise<IDepartmentResponse> => {
    const response = await api.post<IDepartmentResponse>(
      `${environnement.baseURL}/departments`,
      department,
    );
    return response.data;
  },

  /**
   * Mettre à jour un département existant
   * @param department de type IUpdateDepartment (inclut l'id)
   */
  update: async (
    department: IUpdateDepartment,
  ): Promise<IDepartmentResponse> => {
    const response = await api.put<IDepartmentResponse>(
      `${environnement.baseURL}/departments`,
      department,
    );
    return response.data;
  },

  /**
   * Récupérer un département par son ID
   */
  getById: async (id: number): Promise<IDepartmentResponse> => {
    const response = await api.get<IDepartmentResponse>(
      `${environnement.baseURL}/departments/${id}`,
    );
    return response.data;
  },

  /**
   * Supprimer un département
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${environnement.baseURL}/departments/${id}`);
  },

  /**
   * Rechercher des départements par mot-clé
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IDepartmentResponse[]>(
      `${environnement.baseURL}/departments/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
